import { render, staticRenderFns } from "./AppPromptHost.vue?vue&type=template&id=a40dda2a&scoped=true"
import script from "./AppPromptHost.vue?vue&type=script&lang=js"
export * from "./AppPromptHost.vue?vue&type=script&lang=js"
import style0 from "./AppPromptHost.vue?vue&type=style&index=0&id=a40dda2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40dda2a",
  null
  
)

export default component.exports